var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.531 2.5H4.375C3.339 2.5 2.5 3.34 2.5 4.375v7.5c0 1.036.84 1.875 1.875 1.875h6.766l3.546 3.75v-3.75h.938c1.036 0 1.875-.84 1.875-1.875V10m0-5.156a2.344 2.344 0 1 1-4.687 0 2.344 2.344 0 0 1 4.687 0Z",
    stroke: "#002FF1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotificationsIcon);
export default __webpack_public_path__ + "static/media/profile-notifications-icon.d690560a066a9ff7f147776df6094361.svg";
export { ForwardRef as ReactComponent };